import axios from 'axios';

import { getAuthorizationHeader } from './auth_service';

export const getDocuments = async () => {
  let res = await axios.get(process.env.REACT_APP_BACKEND_URL + 'api/documents', getAuthorizationHeader())
  return res;
}

export const getDocumentById = async (id) => {
  let res = await axios.get(process.env.REACT_APP_BACKEND_URL + `api/documents/${id}?populate=*`, getAuthorizationHeader())
  return res.data.data;
}